import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-日志",
  "use": "icon-日志-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-日志\"><path d=\"M936.256 113.536H199.808V1024h505.6l0.128-0.128h230.848l-0.128-910.336zM839.68 0H87.616v896.832h62.464V58.56h689.6V0zM307.648 236.672H752.96v137.664H307.648V236.672z m0 261.312H752.96v137.664H307.648V497.984z m0 261.184H752.96v137.664H307.648V759.168z m0 0\" p-id=\"9043\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol